<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.22</b> - Caverns & Inn bug fixes</p>
    <div class="ml-5 pb-4 text-pink-400">
      <div class="font-bold mt-2">Bug Fixes</div>
      <ul class="ml-4 list-disc">
        <li>Fixed Caverns rendering crashes, esp. when tabbing out & back.</li>
        <li>
          Fixed duplicate Inn tournament membership for the same submode (cause of rank
          inconsistencies)
        </li>
        <li>Fixed battle log sometimes not getting entries for battles that just ended.</li>
      </ul>

      <div class="font-bold mt-2">QoL</div>
      <ul class="ml-4 list-disc">
        <li>
          Re-enabled newsletter signup <span class="text-cyan-400">(for 100 free PD!)</span> with
          improved email service - see Pixie Dust modal or "World" modal in the header.
        </li>
      </ul>
    </div>
  </div>
</template>
